import { TLoginDto } from "@/api/services/main/auth/dtos/login.dto";
import { clearOAuthBounceState, rememberOAuthIdentity } from "@/utils/oauthTelemetry";
import { setToken } from "@/utils/token";
import Cookies from "js-cookie";

/**
 * Persists the access/refresh tokens plus the account metadata cookies of a
 * signed-in match user. Shared by the password login and the OAuth handoff
 * callback so both entry points produce the exact same session state.
 */
export const setMatchAuthCookies = (data: TLoginDto): void => {
  setToken(data.accessToken, data.refreshToken);
  Cookies.set("email", data.email);
  Cookies.set("matchId", data.matchId.toString());
  Cookies.set("matchLicenseNumber", data.matchLicenseNumber.toString());
  Cookies.set("userId", data.userId.toString());
  Cookies.set("isMatchUser", data.isMatchUser.toString());
  // Session established — stash the identity while the token is still readable,
  // so an OAuth redirect loop after `logout()` is still reported with this account.
  rememberOAuthIdentity();
  // The hand-off completed, so the bounces that led here were not a loop. Reset the
  // counter, otherwise it keeps counting across a successful login and a later, healthy
  // re-login can trip the loop breaker onto the error page.
  clearOAuthBounceState();
};
